const TRANSACTION_STATUS = {
  SUCCESS: 0,
};

export default TRANSACTION_STATUS;
